import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';

@Injectable()
export class MessageActions {
    static openMessagePreviewDialogJS = createAction('[Messaging:Preview] Open Message Preview Dialog',
        props<{ messageUuid: any, mediaType: any, isTrackingcode: any, messageType: string }>());
}
